import React, { useState } from 'react';
import DatePicker from '../../../../common/inputs/DatePicker/DatePicker';
import { Button, Grid, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Busy from "../../../../Busy";
import { requestMarkManualPaymentInvoiceAsPaid } from "../../../request/invoiceRequests";
import { CallbackActions } from "../../../../../util/ActionUtils";
import {getErrorMessageForStandardResponse} from "../../../../../util/NetworkErrorUtil";
import moment from 'moment';

const MarkInvoiceAsPaidModal = (props) => {

  const { invoice, open, onInvoiceAction, onClose } = props;

  const [datePaid, setDatePaid] = useState(moment());

  const handleClose = () => {
    onClose();
  };

  const onSubmit = (event) => {
    event.preventDefault();

    const successUpdateInvoice = () => {
      Busy.set(false);
      onClose(CallbackActions.SUCCESS, invoice, `Successfully marked invoice ${invoice.transactionNumber} as paid.`);
    };
    const failUpdateInvoice= (error) => {
      Busy.set(false);
      onInvoiceAction(CallbackActions.ERROR, invoice, getErrorMessageForStandardResponse(error));
    };

    Busy.set(true);
    requestMarkManualPaymentInvoiceAsPaid(invoice.transactionId, datePaid, successUpdateInvoice, failUpdateInvoice);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: 'form',
        onSubmit
      }}
    >
      <DialogTitle>
        Record a Payment Made for this Charge
      </DialogTitle>
      <DialogContent>
        <DatePicker
          label='Payment Date'
          value={datePaid}
          onChange={setDatePaid}
        />
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent={"center"}>
          <Button variant="text" onClick={handleClose} >CANCEL</Button>
          <Button variant="contained" type="submit" >MARK AS PAID</Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
export default MarkInvoiceAsPaidModal;
